// The office UI's copy of the welcome-pack eligibility rule (Session AOZ).
//
// THE RULE LIVES ON THE SERVER. resolvesWelcomePackEligible in server/src/lib/welcomeEmail.ts decides
// whether a customer is drafted the welcome email at contract signing, and the preview route refuses
// on the same function. This mirror exists only because the office bundle cannot import server code
// (no client file does), and the customer page needs the answer twice: to decide whether to offer
// "Preview welcome email", and to say what "Follow client type" currently resolves to, which RULE 6
// requires of any override (it must say what it is masking).
//
// Two copies of one rule drift, so they are bound: server/src/lib/derivedState.test.ts runs both over
// every combination of client type and override and fails on any disagreement. Change the server copy
// first; that test then tells you this one is behind.

export interface WelcomePackCustomer {
  clientType?: string | null;
  receivesWelcomePack?: boolean | null;
}

// An explicit true / false is the office's override and wins. Anything else, including a MISSING field
// (an API response from before the column existed), follows the client type: direct yes, intermediary
// no. Reading only a real boolean as an override is the fail-safe direction, because it reproduces the
// behaviour every customer had before Session AOZ rather than switching anyone off.
export function resolvesWelcomePackEligible(customer: WelcomePackCustomer): boolean {
  if (typeof customer.receivesWelcomePack === "boolean") return customer.receivesWelcomePack;
  return customer.clientType !== "intermediary";
}

// The three office settings, and the stored value each one writes. "follow" writes NULL, which is the
// reset path RULE 1 and RULE 6 both require: an override must clear back to "no override", not merely
// flip between two explicit values.
export type WelcomePackSetting = "follow" | "always" | "never";

export function welcomePackSettingOf(stored: boolean | null | undefined): WelcomePackSetting {
  if (stored === true) return "always";
  if (stored === false) return "never";
  return "follow";
}

export function welcomePackValueOf(setting: WelcomePackSetting): boolean | null {
  if (setting === "always") return true;
  if (setting === "never") return false;
  return null;
}
